import {
  useEffect,
  useMemo,
  useState
} from 'react'
import { useQueryClient } from '@tanstack/react-query'
import { useTranslation } from 'react-i18next'

import { langApi, userApi } from 'api'
import { Input, Div } from 'ui'
import { useSnackbar } from 'hooks'

import { ReactComponent as WorldSVG } from 'assets/icons/world.svg'
import { ReactComponent as LangSVG } from 'assets/icons/snackbar/lang.svg'
import { ReactComponent as CheckSVG } from 'assets/icons/check.svg'


const LangSelector = ({ isFull }) => {

  const { t, i18n } = useTranslation()

  const { Snackbar } = useSnackbar('error')

  const { data: langs } = langApi.useGetLangs()
  
  const langOptions = useMemo(
    () => langs.map( l => ({
      value: l.lang,
      label: l.nameNative
    })
  ), [langs])

  const { updateProfile } = userApi.useUpdateProfile()

  const [selected, setSelected] = useState()

  const width = isFull ? '100%' : 70


  const handleLang = (newLang) => {
    if (newLang.value === selected.value) return

    updateProfile({ lang: newLang.lang })
    localStorage.setItem('i18nextLng', newLang.value)
    setSelected(newLang)
    i18n.changeLanguage(newLang.value)

    Snackbar.open({
      message: t('lang:changeMessage'),
      icon: LangSVG
    })
  }

  const formatOptionLabel = ({ value, label }, meta) => {
    if (meta.context === 'value') {
      return value.toUpperCase()
    }
  
    const isSelected = meta.selectValue[0]?.value === value

    return (
      <Div
        display='flex'
        justifyContent='space-between'
        alignItems='center'
        minWidth={100}
      >
        {label}
        {isSelected ? <CheckSVG height={20} /> : ''}
      </Div>
    )
  }


  useEffect(() => {
    if (!langOptions.length) return 

    const lang = localStorage.getItem('i18nextLng')
    const current = langOptions.find(l => l.value === lang)
    setSelected(current)
  }, [langOptions])


  return (
    <Div width={width} minWidth={width}>
      <Input.Select
        options={langOptions}
        placeholder=' '
        size='small'
        hideChevron
        icon={WorldSVG}
        isSearchable={false}
        selected={selected}
        onChange={handleLang}
        formatOptionLabel={formatOptionLabel}
      />
    </Div>
  )
}

export default LangSelector